import React from 'react';
import {Redirect} from "react-router-dom";

import {observer} from 'mobx-react';
import {withStore} from "../hocs";

// @ts-ignore
@withStore
@observer
export class RedirectUrl extends React.Component {
    render() {

        // @ts-ignore
        const {store} = this.props;
        const {redirectUrl} = store?.mainStore;
        return (
            <>
                {redirectUrl ? <Redirect to={redirectUrl}/> :null }
            </>
        );
    }
}


